// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e81790bb","282":"1f47dde9","283":"3b6d5537","453":"821fd3de","463":"dba136d7","713":"c0eabce0","773":"bdd394ab","780":"72ac5c23","831":"0f422a62","842":"cd35a8ea"}[chunkId] + ".chunk.js";
};